import { Injectable, inject } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Injectable({ providedIn: 'root' })
export class TranslationLoader {
  private readonly languageService = inject(LanguageService);

  /**
   *
   * This function makes sure that languages are loaded before app initializes.
   * It is mostly important to be able to use the transloco.translate() function in components.
   * Without this preload, the .translate() function might return "missing translation key" error,
   * however it does not affect template binding translations, such as the async pipe | transloco.
   *
   */
  async preloadTranslations() {
    await this.languageService.loadAvailableLanguages();
    this.languageService.setActiveLanguage();
  }
}
